module.exports = __webpack_public_path__ + "static/media/dropdown.8725722e.svg";